export default __webpack_public_path__ + "static/layout-dont-dark-086b133abb55d2e33c9db098823974c6e3c998a8aebb32d9085cd0624383ed33.png";